
























































































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import { mapState } from "vuex";
import Header from "@/components/Header.vue";
import { VueEditor } from "vue2-editor";
import { parsePhoneNumberFromString } from "libphonenumber-js";
import { GapLogEntry } from "@/store/modules/types";
import { GapLogType } from "@/store/modules/enums";

@Component({
  components: {
    Header,
    VueEditor,
  },
  computed: {
    ...mapState("auth", ["user"]),
  },
  filters: {
    phone: function (phone: string) {
      if (!phone) return null;
      const parsed = parsePhoneNumberFromString(phone, "US");
      if (parsed) return parsed.formatNational();
      return phone;
    },
  },
})
export default class Discharge extends Vue {
  @Prop(Number) readonly id!: number;
  // eslint-disable-next-line
  gap: any = null;
  comment = "";
  quill = {
    toolbar: [
      ["bold", "italic", "underline"],
      [{ list: "bullet" }],
      [{ indent: "-1" }, { indent: "+1" }],
      [{ color: [] }, { background: [] }],
    ],
  };
  files = {
    selected: null as any,
    list: Array<any>(),
  };
  async getGap() {
    this.$store.commit("main/SET_LOADING", true);
    try {
      this.gap = await this.$store.dispatch("gaps/getRecord", this.id);
    } catch (error) {
      console.log(error);
    } finally {
      this.$store.commit("main/SET_LOADING", false);
    }
  }
  async getFiles() {
    try {
      this.files.list = await this.$store.dispatch("gaps/getFiles", this.id);
    } catch (error) {
      console.log(error);
    }
  }
  async saveSubStatus(id) {
    this.$store.commit("main/SET_LOADING", true);
    try {
      await this.$store.dispatch("gaps/saveSubStatus", {
        gapId: this.gap.id,
        subStatusId: id,
      });
      this.gap.subStatusId = id;
    } catch (error) {
      console.log(error);
    } finally {
      this.$store.commit("main/SET_LOADING", false);
    }
  }
  async saveComment(comment: string) {
    if (comment) this.comment = comment;
    if (!this.comment) return;
    const entry: GapLogEntry = {
      gapId: this.gap.id,
      typeId: GapLogType.PROVIDER_COMMENT,
      comment: this.comment,
    };
    this.$store.commit("main/SET_LOADING", true);
    try {
      await this.$store.dispatch("gaps/saveLog", entry);
      this.comment = "";
      this.$bvToast.toast("Your note has been received!", {
        title: "WaitingMed",
        toaster: "b-toaster-top-center",
        autoHideDelay: 2000,
        solid: true,
      });
    } catch (error) {
      console.log(error);
    } finally {
      this.$store.commit("main/SET_LOADING", false);
    }
  }
  fileExt(file) {
    return file.name
      .slice(((file.name.lastIndexOf(".") - 1) >>> 0) + 2)
      .toLowerCase();
  }
  fileIsImage(file) {
    const ext = this.fileExt(file);
    const arr = [
      "jpg",
      "jpeg",
      "tiff",
      "gif",
      "bmp",
      "png",
      "webp",
      "svg",
      "ai",
      "eps",
    ];
    return arr.indexOf(ext) >= 0;
  }
  fileIcon(file) {
    if (this.fileIsImage(file)) {
      return "fa-file-image";
    } else {
      const ext = this.fileExt(file);
      switch (ext) {
        case "doc":
        case "docx":
          return "fa-file-word";
        case "xls":
        case "xlsx":
          return "fa-file-excel";
        case "ppt":
        case "pptx":
          return "fa-file-powerpoint";
        case "pdf":
          return "fa-file-pdf";
        case "txt":
          return "fa-file-alt";
        case "zip":
          return "fa-file-archive";
        case "avi":
        case "wmv":
        case "mov":
        case "qt":
        case "flv":
        case "swf":
        case "mpg":
        case "mpe":
        case "mpv":
        case "mp2":
        case "mp4":
        case "m4p":
        case "m4v":
        case "ogg":
        case "mpeg":
        case "webm":
          return "fa-file-video";
        default:
          return "fa-file";
      }
    }
  }
  async fileView(file) {
    this.$store.commit("main/SET_LOADING", true);
    try {
      const gapId = this.id;
      const { storageId } = file;
      const { uri } = await this.$store.dispatch("gaps/getFileUrl", {
        gapId,
        storageId,
      });
      window.open(uri, "_blank");
    } catch (error) {
      console.log(error);
    } finally {
      this.$store.commit("main/SET_LOADING", false);
    }
  }
  async fileDownload(file) {
    this.$store.commit("main/SET_LOADING", true);
    try {
      const gapId = this.id;
      const { storageId } = file;
      const { uri } = await this.$store.dispatch("gaps/getFileDownloadUrl", {
        gapId,
        storageId,
      });
      window.location.href = uri;
    } catch (error) {
      console.log(error);
    } finally {
      this.$store.commit("main/SET_LOADING", false);
    }
  }
  mounted() {
    this.getGap();
    this.getFiles();
  }
}
